<template>
  <div>
    <div
      class="prod-items"
      v-for="item in goodsList"
      :key="item.id"
      @click="gotodetail(item.prodId)"
    >
      <div class="hot-imagecont">
        <img :src="item.pic" class="hotsaleimg" />
      </div>
      <div class="hot-span">
        <div class="hotprod-span">{{ item.prodName }}</div>
        <div class="prod-info" v-if="sts == 6">
          {{ item.prodCommNumber }}评价 {{ item.positiveRating }}%好评
        </div>
        <div
          class="'prod-span-info'"
        >
          <div class="price">
            <img v-if="currentActivityId == 13" src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" alt="积分" style="width: 16px; height: 16px; margin-right: 4px;"/>
            <span v-if="currentActivityId != 13" class="symbol">￥</span>
            <span class="big-num">{{ item.price }}</span>
            <span class="original-price" v-if="item.oriPrice && currentActivityId != 16">
              <span class="symbol">原价：</span>
              <span class="ori-num">{{ item.oriPrice }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityIdFromRoute } from '@/utils/urlUtil';

export default {
  name: "products",
  props: ["goodsList"],
  data() {
    return {};
  },
  // computed: {
  //   // 从全局状态获取活动ID
  //   globalActivityId() {
  //     return this.$store.getters.getActivityId;
  //   },
  //   // 根据路由和全局状态获取当前活动ID
  //   currentActivityId() {
  //     // 从路由中获取活动ID
  //     const urlActivityId = getActivityIdFromRoute(this.$route);
  //     // 从全局状态获取活动ID
  //     const globalActivityId = this.globalActivityId;
      
  //     // 如果URL中存在活动ID，优先使用URL中的活动ID
  //     return urlActivityId || globalActivityId;
  //   }
  // },
  methods: {
    gotodetail(id_) {
      this.$router.push({ path: "/productDetail", query: { id: id_ } });
    },
    
  },
};
</script>

<style lang="less" scoped>
// .goods_list {
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: space-between;
//   font-size: 16px;
//   line-height: 20px;
//   span-align: center;
//   li {
//     width: 48%;
//     img {
//       width: 100%;
//     }
//   }
// }
.prod-items {
  width: 172.5px;
  display: inline-block;
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  margin-left: 10px;
  margin-bottom: 10px;
  border-radius: 5px;

}

.hot-imagecont .hotsaleimg {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.hot-span .hotprod-span {
  height: 38px;
  line-height: 19px;
  font-size: 14px;
  display: -webkit-box;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #000;
}

.prod-items .hot-imagecont {
  text-align: center;
  font-size: 0;
  width: 152px;
  height: 152px;
}

.prod-items .hot-span {
  margin-top: 10px;
}

.prod-items .hot-span .prod-info {
  font-size: 10px;
  color: #777;
  margin-top: 4px;
  margin-left: 8px;
}

.prod-items .hot-span .prod-span-info {
  position: relative;
  height: 20px;
  line-height: 20px;
  font-family: Arial;
  margin-top: 10px;
}
.collection-row {
  display: flex;
  justify-content: space-between;
}

.price {
  color: #e43130;
}
.deadline-price{
  font-size: 11px;
  margin-right:2.5px;
}

.basket-img{
  width: 25px;
  height: 25px;
  position: absolute;
  right: 0;
  bottom: 3px;
  padding: 4px;
}
.symbol {
    font-size: 12px;
}
.big-num {
    font-size: 16px;
}
.original-price {
     margin-left: 8px;
     color: #999;
}
.original-price .symbol, .original-price .ori-num {
     font-size: 11px;
     text-decoration: line-through;
}
</style>
